module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/glyphicons-halflings-regular.woff2
// module id = ./node_modules/@ps/common-core/dist/fonts/glyphicons-halflings-regular.woff2
// module chunks = 1